module.exports = __webpack_public_path__ + "img/totalmeetings500.047d2ac3.png";